import { render, staticRenderFns } from "./MapPlaceholder.vue?vue&type=template&id=15683c25&"
import script from "./MapPlaceholder.vue?vue&type=script&lang=ts&"
export * from "./MapPlaceholder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports